import { createFileRoute } from "@tanstack/react-router";

import { sessionQuery } from "@/features/auth/queries";
import { masterTypeIndexQuery } from "@/features/master-types/queries";
import { RecordFormPage } from "@/features/records/components/RecordFormPage";
import { activeSchemaQuery } from "@/features/schema/queries";

export const Route = createFileRoute("/_authed/records/$code/new")({
  staticData: {
    crumbs: [
      { key: "nav.records", to: "/records" },
      { param: "code" },
      { key: "nav.breadcrumb.new" },
    ],
  },
  loader: async ({ context, params }) => {
    const me = await context.queryClient.ensureQueryData(sessionQuery);
    await Promise.all([
      context.queryClient.ensureQueryData(masterTypeIndexQuery(me.resolved_locale)),
      context.queryClient.ensureQueryData(activeSchemaQuery(params.code)),
    ]);
  },
  component: NewRecord,
});

function NewRecord() {
  const { code } = Route.useParams();
  return <RecordFormPage code={code} />;
}
